export const MISSING_SECTION_BOOKMARK_ERROR = "MissingSectionBookmarkError";

export const getMissingSectionBookmarkMessage = (sectionName?: string) =>
  `Section${sectionName ? ` "${sectionName}"` : ""} does not exist in the document.`;

export const createMissingSectionBookmarkError = (sectionName?: string) => {
  const error = new Error(getMissingSectionBookmarkMessage(sectionName));
  error.name = MISSING_SECTION_BOOKMARK_ERROR;
  return error;
};

export const isMissingSectionBookmarkError = (error: any) => error?.name === MISSING_SECTION_BOOKMARK_ERROR;
